import { render, staticRenderFns } from "./VehicleSelectionTable.vue?vue&type=template&id=08713a7b&scoped=true&"
import script from "./VehicleSelectionTable.vue?vue&type=script&lang=js&"
export * from "./VehicleSelectionTable.vue?vue&type=script&lang=js&"
import style0 from "./VehicleSelectionTable.vue?vue&type=style&index=0&id=08713a7b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08713a7b",
  null
  
)

export default component.exports